import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ]
})
export class CmreqModule {}